import React from 'react';
import { connect } from 'react-redux';

// Constants

import { AccessCodeErrorModal } from '@components/individualPortal/dashboard/modals/AccessCodeErrorModal';
import  { ModalTypes } from '@constants/individualPortal/modals/types';

/**
 *
 * @param {Object} props - contains "modal" props from Redux Store
 * @returns {React.Component} - modal layout and needed content for Modal
 *
 */
const ModalContainer = props => {

    const {
        actions,
        data,
        modal,
        modal: {
            modalType
        },
        ...restProps
    } = props;

    const extendedProps = {
        ...restProps,
        actions,
        data,
        modal
    };

    const getModal = () => {
        if (modalType === ModalTypes.ACCESS_CODE_INVALID_MODAL) {
            return <AccessCodeErrorModal {...extendedProps }/>;
        }
    };

    return getModal();
};

const mapStateToProps = state => ({
    environment: state.common.environment,
});

export default connect(mapStateToProps)(ModalContainer);
